module.exports = __webpack_public_path__ + "static/img/video_quiz_title.8478a96.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/video_quiz/video_quiz_title.png
// module id = gKUq
// module chunks = 1